<div matDialogTitle>{{title}}</div>
<div>{{message}}</div>
<mat-dialog-actions>
    <button mat-raised-button matDialogClose>Stäng</button>
</mat-dialog-actions>